const MAX_AVATAR_SIZE = 400;

export function resizeImage(file, maxSize = MAX_AVATAR_SIZE) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            const image = new Image();
            image.onload = () => {
                const scale = Math.min(1, maxSize / image.width, maxSize / image.height);
                const width = Math.max(1, Math.round(image.width * scale));
                const height = Math.max(1, Math.round(image.height * scale));
                const canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;
                canvas.getContext("2d").drawImage(image, 0, 0, width, height);
                resolve(canvas.toDataURL(file.type || "image/png"));
            };
            image.onerror = reject;
            image.src = event.target.result;
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}
